import React from "react";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  /** Accent color of the moving arc. */
  tone?: "primary" | "accent" | "current";
}

const sizeMap = {
  sm: "w-4 h-4 border-2",
  md: "w-8 h-8 border-2",
  lg: "w-12 h-12 border-[3px]",
} as const;

const toneMap = {
  primary: "border-blue-500/25 border-t-blue-400",
  accent: "border-accent-500/25 border-t-accent-400",
  current: "border-current/25 border-t-current",
} as const;

/** A single, consistent spinner — replaces the ad-hoc inline spinners across the app. */
const Spinner: React.FC<SpinnerProps> = ({
  size = "md",
  tone = "primary",
  className = "",
}) => (
  <span
    role="status"
    aria-label="Loading"
    className={`inline-block rounded-full animate-spin ${sizeMap[size]} ${toneMap[tone]} ${className}`}
  />
);

export default Spinner;
